import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "wo-item-image-container"
};
const _hoisted_2 = {
  class: "wo-item-title"
};
const _hoisted_3 = {
  class: "wo-item-desc"
};
import { placeholderImage } from '@/tools/utils';
export default {
  __name: 'WOItemCard',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    desc: {
      type: String,
      required: false,
      default: ''
    },
    image: {
      type: String,
      required: false,
      default: null
    }
  },

  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["wo-item-card", __props.title && __props.title.length !== 0 ? '' : 'empty-card'])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_image, {
        class: "wo-item-image",
        src: __props.image && __props.image.length > 0 ? __props.image : _unref(placeholderImage),
        draggable: "false"
      }, null, 8, ["src"])]), _createElementVNode("text", _hoisted_2, _toDisplayString(__props.title), 1), _createElementVNode("text", _hoisted_3, _toDisplayString(__props.desc), 1)], 2);
    };
  }

};